/**
 * IResultData // domain>shared>result.ts
 * Result // neverthrow interface
 * HttpError // shared>errors>httpError
 * ParseError // shared>errors>parseError
 * LineTypeCode // @/types
 */

import { IBoardInfo } from "@/domain/entities/board";
import { Result } from "neverthrow";
import { HttpError } from "../shared/errors/httpError";
import { ParseError } from "../shared/errors/parseError";
import { IResultData } from "@/domain/entities/shared/result";
import { LineTypeCode, LineTypeName } from "@/types";
import { HttpEarlyDriveInfo } from "../lineInfo/lineInfoRepository.types";
import { ICustomCode } from "@/domain/entities/system/customCode.types";

export type HttpBoardInfoResponse = {
  data: HttpBoardInfo[];
};

export type HttpBoardInfo = {
  boardUid: string;
  lineTypeCode: LineTypeCode;
  lineTypeName: LineTypeName;
  lineRouteNo: string;
  lineRouteName: string;
  lineTurnUid: string;
  carNo?: string;
  vendorName?: string;
  gateNo: string[];
  earlyDriveWeekly?: HttpEarlyDriveInfo[];
  realOnStationUid: string;
  realOnStationName: string;
  realOnStationLat: number;
  realOnStationLng: number;
  realOnDtm: string;
  lineSurveyYn: boolean;
  allocUid: string;
  campusName: string;
  expectedBeginDtm: string; // hh:mm

  // 예약노선인 경우
  bookTs?: string;
  expectedOnStationUid?: string;
  expectedOnStationName?: string;
  expectedOnDtm?: string; // hh:mm
  onStationLat?: number;
  onStationLng?: number;
  expectedOffStationUid?: string;
  expectedOffStationName?: string;
  expectedOffDtm?: string; // hh:mm
  offStationLat?: number;
  offStationLng?: number;
};

// parser에서는 Http에서 전달된 데이터를 parse하여 view에서 사용가능한 IBoardInfo 배열로 만들 예정.
export interface IBoardInfoParser {
  toDomain(data: HttpBoardInfo[]): Result<IBoardInfo[], ParseError>;
}

/**
 * get 요청.
 * 쿼리스트링으로 from날짜, to날짜, sortOrder를 파라미터를 보냄.
 * accessToken으로 인증을 보냄.
 */
export interface IBoardRepository {
  getBoardingHistory(
    boardDtmFrom: string,
    boardDtmTo: string,
    sortOrder?: string
  ): Promise<Result<IBoardInfo[], ParseError | HttpError>>;

  requestReport(
    boardUid: string,
    reportReason: ICustomCode
  ): Promise<Result<IResultData, ParseError | HttpError>>;

  requestGetOffBus(
    boardUid: string,
    getOffBusStopId: string,
    getOffYn: boolean
  ): Promise<Result<IResultData, ParseError | HttpError>>;
}
